import React, { Component} from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../images/admin-logo.png";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faRectangleList, faComments, faDownload } from '@fortawesome/free-solid-svg-icons'

function LeftMenu(){

const nav = useNavigate();
const logout = () => {
  confirmAlert({
    title: "Confirm to Log Out",
    message: "Are you sure you want to terminate your current session!",
    buttons: [
      {
        label: "Yes",
        onClick: async () => {
          localStorage.clear();
          swal({
            title: "Wow!",
            text: "Account Logged Out Successfully.",
            icon: "success",
            button: "Okay",
          });
          nav('/admin/login');
        },
      },
      {
        label: "No",
        onClick: () => {},
      },
    ],
  });
}

const isSelectedTab = (string) => {
  //console.log('full path => ', window.location.href.replace(window.location.origin,''))
  const newStr = window.location.href.replace(window.location.origin,'')
  //console.log('current status => ', newStr == string ? true : false)
  return newStr == string ? true : false
}
  //export default function LeftMenu() {
   
        return (
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
            {/* Brand Logo */}
           
            {/* Sidebar */}
            <div className="sidebar">
              {/* Sidebar user panel (optional) */}
    
              {/* Sidebar Menu */}
              <nav className="mt-2 brand-link">
              <div className='text-center mt-4'>
              <NavLink to="/admin/dashboard">
                <img src={Logo}/>
              </NavLink>
              </div>
              
              
                <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                  <li className="nav-item has-treeview">
                    <NavLink to="/admin/dashboard" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
                    <i class="nav-icon fas fa-tachometer-alt"></i>
                      <p>Dashboard</p>
                    </NavLink>
                  </li>
                  <li className="nav-item has-treeview">
                    <NavLink to="/admin/users-list" className={( (isSelectedTab('/admin/users-list') || isSelectedTab('/admin/add-user') || isSelectedTab('/admin/edit-user')) ? "nav-link active" : "nav-link")}>
                      <i class="nav-icon fas fa-user"></i>
                      <p>User Management</p>
                    </NavLink>
                  </li>
                  <li className="nav-item has-treeview">
                    <NavLink to="/admin/api-users" className={( (isSelectedTab('/admin/api-users') || isSelectedTab('/admin/api-users/add') || isSelectedTab('/admin/api-users/edit')) ? "nav-link active" : "nav-link")}>
                      <i class="nav-icon fas fa-user"></i>
                      <p>Api Users</p>
                    </NavLink>
                  </li>
                  <li className="nav-item has-treeview">
                    {/* {<NavLink to="/admin/email-list" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>} */}
                    <NavLink to="/admin/email-list" className={( (isSelectedTab('/admin/email-list') || isSelectedTab('/admin/email-edit')) ? "nav-link active" : "nav-link")}>
                    &nbsp;<FontAwesomeIcon icon={faEnvelope} className="iconStyle"/>&nbsp;&nbsp;
                      <p>Email Management</p>
                    </NavLink>
                  </li>
                  <li className="nav-item has-treeview">
                    <NavLink to="/admin/static-content-list" className={( (isSelectedTab('/admin/static-content-list') || isSelectedTab('/admin/static-content-edit')) ? "nav-link active" : "nav-link")}>
                    &nbsp;<FontAwesomeIcon icon={faRectangleList} className="iconStyle"/>&nbsp;&nbsp;
                      <p>Static Content</p>
                    </NavLink>
                  </li>
                  <li className="nav-item has-treeview">
                    <NavLink to="/admin/faq-list" className={( (isSelectedTab('/admin/faq-list') || isSelectedTab('/admin/faq-add') || isSelectedTab('/admin/faq-edit')) ? "nav-link active" : "nav-link")}>
                    &nbsp;<FontAwesomeIcon icon={faComments} className="iconStyle"/>&nbsp;&nbsp;
                      <p>FAQ Management</p>
                    </NavLink>
                  </li>
                  <li className="nav-item has-treeview">
                    <NavLink to="/admin/download-excel" className={( isSelectedTab('/admin/download-excel') ? "nav-link active" : "nav-link")}>
                    &nbsp;<FontAwesomeIcon icon={faDownload} className="iconStyle"/>&nbsp;&nbsp;
                      <p>Download Excel</p>
                    </NavLink>
                  </li>
                  <li className="nav-item has-treeview">
                  
                   <div style={{"margin-left": "22px"}}>
                   <button className='btn btn-danger' onClick={logout}>Logout</button>
                   </div>
                  </li>
                </ul>
              </nav>
              {/* /.sidebar-menu */}
            </div>
            {/* /.sidebar */}
          </aside>

        )
    }
export default LeftMenu